module.exports = __webpack_public_path__ + "img/AIA.990ed517.svg";